/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import BookRoot from 'book-root';
/* eslint-enable import/no-unresolved, import/no-extraneous-dependencies */

export default BookRoot;



// WEBPACK FOOTER //
// ./book/src/commons/components/Root.jsx